import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./it.json";
import en from "./en.json";

/**
 * i18n setup — Italiano (default) + English. Le altre lingue nel profilo utente
 * (fr, es) sono accettate dal backend ma per ora rendono la UI in italiano.
 * Facile estendere: basta aggiungere `fr.json` / `es.json` e includerle nelle
 * risorse qui sotto.
 */
i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: "it",
  fallbackLng: "it",
  interpolation: { escapeValue: false }, // React already escapes
  returnEmptyString: false,
});

export default i18n;
